import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FaIconProps } from './types'

const sizes = {
    sm: '0.875rem',
    md: '1rem',
    lg: '1.25rem',
}

export default function FaIcon({ icon, size = 'md' }: FaIconProps) {
    return (
        <FontAwesomeIcon
            icon={icon}
            fontSize={sizes[size]}
            color="currentColor"
        />
    )
}
